export const TOAST = {
    SHOW_TOAST: 'TOAST.SHOW_TOAST',
    HIDE_TOAST: 'TOAST.HIDE_TOAST',
}